/* unplugin-vue-components disabled */import { render } from "./CNoData.vue?vue&type=template&id=c0b30bda&scoped=true&ts=true"
import script from "./CNoData.vue?vue&type=script&lang=ts"
export * from "./CNoData.vue?vue&type=script&lang=ts"

import "./CNoData.vue?vue&type=style&index=0&id=c0b30bda&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0b30bda"]])

export default __exports__